<div class="periodic-compliance-container">
  <app-compliance-tasks
    taskType="periodic"
    [columns]="columns"
    [data]="periodicComplianceTasks"
    [isLoading]="isLoading"
    [isLoadingMore]="isLoadingMore"
    [hasError]="hasError"
    [minWidth]="1100"
    (rowClicked)="onRowClick($event)"
    (editClicked)="onEditClick($event)"
    (rescheduleClicked)="onRescheduleClick($event)"
    (deleteClicked)="onDeleteClick($event)"
    (searchChanged)="onSearch($event)"
    (statusFilterChanged)="onStatusFilter($event)"
    (scrolledDown)="onScrollDown()">
  </app-compliance-tasks>
</div>